import { usePreferences } from './preferences-store'

const APPLIED_KEY = 'fundus.home-applied'

const HOME_PATHS = { parts: '/parts', storage: '/locations' } as const

/**
 * Where `/` should send someone who has just opened Fundus, or null to stay.
 * Only the first visit in a browser session is redirected: after that `/` is
 * the Overview, which the sidebar has to be able to reach.
 */
export function homeRedirect(): '/parts' | '/locations' | null {
  let applied = false
  try {
    applied = sessionStorage.getItem(APPLIED_KEY) === '1'
    sessionStorage.setItem(APPLIED_KEY, '1')
  } catch {
    // No session storage: redirecting every time would trap the Overview, so don't.
    return null
  }
  if (applied) return null
  const home = usePreferences.getState().home
  return home === 'overview' ? null : HOME_PATHS[home]
}
